/*
 * Datazoom, Inc ("COMPANY") CONFIDENTIAL
 * Copyright (c) 2017-2018 [Datazoom, Inc.], All Rights Reserved.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */

import { USER_ROLES_LIST, USER_STATUS } from "../../app/Constants/Constants";
import { changeGroupName } from "../../app/Utilities/utils";
import {
  COLLECTOR_BLOCKED_YES,
  USER_ROLE,
  SUPER_ADMIN_ROLE,
  ADMIN_ROLE,
  STATUS_PENDING,
} from "../../constants/Constants";

export const titles = [
  {
    key: "status",
    label: "Status",
    sortable: true,
    sortKey: "is_blocked",
  },
  {
    key: "name",
    label: "Name",
    sortable: true,
    sortKey: "full_name",
  },
  {
    key: "email",
    label: "Email Address",
  },
  {
    key: "role",
    label: "Role",
  },
];
export const getListViewObj = /* istanbul ignore next */ (user, auth) => {
  let role = "";
  switch (user.roleName) {
    case USER_ROLE:
      role = "Standard User";
      break;
    case SUPER_ADMIN_ROLE:
      role = "Super Admin";
      break;
    case ADMIN_ROLE:
      role = "Admin";
      break;
    default:
      /* istanbul ignore next */
      role = "Standard User";
  }
  const obj = {
    key: user.userId,
    status: {
      value:
        user.status !== STATUS_PENDING &&
        user.isBlocked === COLLECTOR_BLOCKED_YES,
      pending: user.status === STATUS_PENDING,
      view: "status",
    },
    name: {
      value: user.name,
      pending: user.status === STATUS_PENDING,
    },
    email: {
      value: user.email,
    },
    role: {
      value: role,
    },
    _info: {
      email: user.email,
      full_name: user.name,
      company_id: user.companyUUID,
      roleName: user.roleName,
      user_id: user.userId,
      status: user.status,
      is_blocked: user.isBlocked,
      key: user.userId,
    },
    company: { value: undefined },
  };
  /* istanbul ignore else */
  if (auth && auth.user && auth.user.roleName === SUPER_ADMIN_ROLE) {
    obj.company = {
      value: user.companyName,
    };
  }
  obj.action = {
    value: user.status === STATUS_PENDING,
    view: "action",
    clickHandler: "btnClickHandler",
  };
  return obj;
};

export const getAllUserListViewObj = /* istanbul ignore next */ (
  user,
  auth,
) => {
  /* istanbul ignore next */
  let role = "";
  switch (user.roleName) {
    case USER_ROLE:
      role = "Standard User";
      break;
    case SUPER_ADMIN_ROLE:
      role = "Super Admin";
      break;
    case ADMIN_ROLE:
      role = "Admin";
      break;
    default:
      /* istanbul ignore next */
      role = "Standard User";
  }
  const userVO = {
    company_id: user?.companyUUID,
    name: user.name === null ? user.email : user.name,
    email: user.email,
    id: user.userId,
    status: user.status,
    exclude: user.status === "PENDING" || user.status === "INVITED",
    role,
    external: user?.isExternal,
  };
  return userVO;
};

export const filterBoxData = /* istanbul ignore next */ (
  companies,
  currentRole,
  roles,
) => {
  const DPList = [
    {
      name: "Status",
      DPValue: USER_STATUS.sort().map(
        /* istanbul ignore next */ (status) => {
          return {
            id: Math.random().toString(36).slice(2, 7),
            name: status.name,
            value: status.value,
            type: "status",
          };
        },
      ),
    },
    {
      name: "Role",
      DPValue: roles
        ?.filter(
          /* istanbul ignore next */ (role) =>
            currentRole !== SUPER_ADMIN_ROLE ? role !== SUPER_ADMIN_ROLE : role,
        )
        .sort()
        .map(
          /* istanbul ignore next */ (role) => {
            return {
              id: Math.random().toString(36).slice(2, 7),
              name: changeGroupName(role),
              value: role,
              type: "role",
            };
          },
        ),
    },
    {
      name: "Company",
      DPValue: companies.map(
        /* istanbul ignore next */ (company) => {
          return {
            id: Math.random().toString(36).slice(2, 7),
            value: company.companyuuid,
            name: company.company_name,
            type: "company_id",
          };
        },
      ),
    },
  ];
  if (currentRole !== SUPER_ADMIN_ROLE) {
    return {
      DPList: DPList.filter(
        /* istanbul ignore next */ (value) => value.name !== "Company",
      ),
    };
  }
  return {
    DPList,
  };
};

export const filterDefaultData = /* istanbul ignore next */ () => {
  return {
    id: Math.random().toString(36).slice(2, 7),
    name: "Active",
    value: "Active",
    type: "status",
  };
};

export const filterApiData = /* istanbul ignore next */ (filterData) => {
  const status = [];
  const role = [];
  const company_id = [];
  filterData.map(
    /* istanbul ignore next */ (data) => {
      switch (data.type) {
        case "status":
          if (data.name !== "Disabled") {
            status.push(data.value);
          } else {
            status.push(data.value);
            status.push("Admin_Rejected");
          }
          break;
        case "role":
          role.push(data.value);
          break;
        case "company_id":
          company_id.push(data.value);
          break;
        default:
          break;
      }
    },
  );
  return {
    status,
    role,
    company_id,
  };
};

export const getUserDataDetails = /* istanbul ignore next */ (user) => {
  if (!user.data) {
    return;
  }
  return {
    companyuuid: user.data.companyId,
    company_name: user.data.companyName,
    name: user.data.name,
    email: user.data.email,
    id: user.data.userId,
    status: user.data.status,
    roleName: user.data.roleName,
    external: user?.data?.external,
  };
};
export const filterPendingtData = /* istanbul ignore next */ () => {
  return {
    id: Math.random().toString(36).slice(2, 7),
    name: "Pending Approval",
    value: "Pending",
    type: "status",
  };
};
